(function unitOrgComboControlModuleDefinition() {
    'use strict';

    angular.module('UnitOrgComboControl', [])
        .directive('crUnitOrgComboControl', ['$translate', 'organizationalUnitService', 'errorsExtend',
            function ($translate, organizationalUnitService, errors) {
                return {
                    scope:
                    {
                        unitOrgId: '=',
                        labelName: '@',
                        allOu: '@',
                        unitOrgNotInId: '=',
                        selectedOu: "=ngModel",
                        parentfun: '&',
                        placeholder: '@',
                        emptyOu: '&'
                    },

                    controller: [
                        '$scope', '$element', function ($scope, $element) {

                            $scope.organizationalUnits = [];

                            organizationalUnitService.getOuTReeControl().then(function getOk(result) {
                                $scope.organizationalUnits = result;

                                if (!$scope.emptyOu()) {

                                    $scope.selectedOu = result.filter(function (ou) { return ou.id == $scope.unitOrgId; })[0];

                                    if ($scope.selectedOu == undefined) {
                                        $scope.selectedOu = result[0];
                                    }
                                } else {
                                    $scope.organizationalUnits.unshift({ name: "ALL" });
                                    $scope.selectedOu = $scope.organizationalUnits[0];
                                }


                            }, function getError(error) {
                                errors.showError(error);
                            });
                        }],

                    templateUrl: '/app/directives/unit-org-combo-control/unit-org-combo-control.html',
                    link: function () {
                    }
                };
            }
        ]);
})();